import { useQuery } from '@tanstack/react-query';

import { getCartLocks } from '../cart-lock';

export function useGetCartLocks(eventId: number) {
  return useQuery({
    queryKey: ['cart-locks', eventId],
    refetchInterval: 15000,
    queryFn: async () => getCartLocks(eventId),
  });
}
